import { render } from "./SearchResultsCompanyScan.vue?vue&type=template&id=47a822b2&scoped=true"
import script from "./SearchResultsCompanyScan.vue?vue&type=script&lang=js"
export * from "./SearchResultsCompanyScan.vue?vue&type=script&lang=js"

import "./SearchResultsCompanyScan.vue?vue&type=style&index=0&id=47a822b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a822b2"]])

export default __exports__